// eslint-disable-next-line import/prefer-default-export
export const en = {
  common: {
    continued: 'Continued',
    work_order: 'Work Order',
    application: 'Application',
    generated_on: 'Generated on',
    copyright: '© Copyright',
    getByDisplayText: (name: string, date: string) =>
      name ? `${date} by ${name}` : `${date}`,
    getPageNumberText: (pageNumber: number, totalPages: number) =>
      `${pageNumber} of ${totalPages}`
  },
  details: {
    title: 'Details',
    authorization: 'Authorization',
    target_time: 'Target Time',
    actual_time: 'Actual Time',
    start_time: 'Start Time',
    start_time_short: 'Start',
    end_time: 'End Time',
    work_type: 'Work Type',
    timing_event: 'Timing Event',
    application_method: 'Application Method',
    most_restrictive: 'Most Restrictive',
    rei_estimation: 'REI Estimation',
    phi_estimation: 'PHI Estimation',
    rei_expiration: 'REI Expiration',
    phi_expiration: 'PHI Expiration',
    equipment: 'Equipment',
    record_created: 'Record Created'
  },
  applicators: {
    title: 'Applicators',
    name: 'Name',
    license: 'License',
    company: 'Company',
    expires: 'Expires',
    continued: 'Applicators continued onto next page'
  },
  weather: {
    title: 'Weather',
    sky_condition: 'Sky Condition',
    temperature: 'Temperature',
    relative_humidity: 'Relative Humidity',
    wind: 'Wind',
    soil_moisture: 'Soil Moisture',
    start: 'Start',
    end: 'End'
  },
  tags: {
    title: 'Tags'
  },
  notes: {
    title: 'Notes',
    continued: 'Notes continued onto next page'
  },
  tank_information: {
    title: 'Tank Information',
    tank_size: 'Tank Size',
    tank_count: 'Tank Count',
    overall_rate_per_acre: 'Overall Rate/Ac',
    overall_total_product: 'Overall Total Product'
  },
  products: {
    title: 'Products',
    name: 'Name',
    epa_number: 'EPA Number',
    application_method: 'Appl. Method',
    target_pest: 'Target Pest',
    rei: 'REI',
    phi: 'PHI',
    application_area: 'Appl. Acres',
    rate_per_acre: 'Rate/Ac',
    rate_per_tank: 'Rate/Tank',
    total_product: 'Total Product',
    continued: 'Products continued onto next page',
    withLineBreaks: {
      name: 'Name',
      epa_number: `EPA \n Number`,
      application_method: `Appl. \n Method`,
      target_pest: `Target \n Pest`,
      rei: 'REI',
      phi: 'PHI',
      application_area: `Appl. \n Acres`,
      rate_per_acre: 'Rate/Ac',
      rate_per_tank: 'Rate/Tank',
      total_product: `Total \n Product`
    }
  },
  properties: {
    title: 'Properties',
    farm: 'Farm',
    field: 'Field',
    crop_zone: 'Crop Zone',
    crop: 'Crop',
    center_lat_long: 'Center Lat/Long',
    applied_acreage: 'Applied Acreage',
    actual_acres: 'Actual Acres',
    total_applied_acreage: 'Total Applied Acreage',
    continued: 'Properties continued onto next page'
  },
  signature: {
    signature: 'Signature',
    date: 'Date'
  },
  worker_protection: {
    title: 'Worker Protection',
    signal_word: 'Signal word',
    rup: 'RUP',
    ppe: 'PPE',
    reEntry: 'ReEntry',
    continued: 'Worker Protection continued onto next page'
  }
};
